/* eslint-disable no-undef */
export const VdpButtons = {
  data() {
    return {
      modals: {
        visibility: {
          requestInformation: false,
          tradeInAppraisal: false,
          testDrive: false,
          paymentCalculator: false,
        },
      },
    }
  },
  methods: {
    buttonClick(button, label) {
      if (button == 'RequestInformation')
        this.showRequestInformationModal();
      if (button == 'TradeInAppraisal')
        this.showTradeInAppraisalModal();
      if (button == 'TestDrive')
        this.showTestDriveModal();
      if (button == 'PaymentCalculator')
        this.showPaymentCalculatorModal();

        var payload = {'event_category': 'LBX-VDP', 'event_label': 'LBX-' + label};
        window.sendGAEvent('LBX-' + button + '-Click', payload);
    
      //console.log("GTAG SENT ACTION " + 'LBX-' + button + '-Click' + " LABEL " + label);
    },
    showRequestInformationModal() {
      this.modals.visibility.requestInformation = true;
    },
    hideRequestInformationModal() {
      this.modals.visibility.requestInformation = false;
    },
    showTradeInAppraisalModal() {
      this.modals.visibility.tradeInAppraisal = true;
    },
    hideTradeInAppraisalModal() {
      this.modals.visibility.tradeInAppraisal = false;
    },
    showTestDriveModal() {
      this.modals.visibility.testDrive = true;
    },
    hideTestDriveModal() {
      this.modals.visibility.testDrive = false;
    },
    showPaymentCalculatorModal() {
      this.modals.visibility.paymentCalculator = true;
    },
    hidePaymentCalculatorModal() {
      this.modals.visibility.paymentCalculator = false;
    },
  },
}
